<template>
  <div v-if="localSpans && localInputValue">
    <div class="my-8">
      <h5>延長パターン名</h5>
      <v-text-field
        v-model="localInputValue.patternTitle"
        variant="outlined"
        hide-details
        density="compact"
      ></v-text-field>
    </div>
  
    <div v-for="(item, i) in localSpans.spans" :key="item._id || i">
      <div class="menu-header">時間枠{{i+1}}</div>
  
      <div class="my-8">
        <div class="my-8">
          <billing-input
            :hideMonthly="true"
            :billingMethod="item.billingMethod"
            @billingMethod="item.billingMethod = $event"
            :hourly="item.hourly"
            @hourly="item.hourly = $event"
            :monthly="item.monthly"
            @monthly="item.monthly = $event"
          ></billing-input>
        </div>
      </div>
  
    </div>
  
    <div class="d-flex">
      <v-btn
        @click="addSpanRow"
        color="primary"
        variant="outlined"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  
    <div class="my-12 d-flex justify-center">
      <v-btn 
        @click="updatePattern"
        v-if="isUpdatable"
        color="primary"
        :loading="isLoading"
        variant="flat"
        size="large"
      >保存</v-btn>
      <v-btn
        @click="createPattern"
        v-else
        color="primary"
        :loading="isLoading"
        variant="flat"
        size="large"
      >作成</v-btn>
    </div>
  
  </div>
  </template>
  
  <script lang="ts">
  import { nurseryHoursModule, CreateSpansInput, CreateSpotFlexibleInput } from '@/store/dataModules/nurseryHoursModule'
  // import TimeInput from '@/components/organisms/nursery-hours/TimeInput.vue'
  import BillingInput from '@/components/organisms/nursery-hours/BillingInput.vue';
  import { defineComponent } from 'vue'
  import LocalDataService from '@/service/LocalDataService';
  import Swal from 'sweetalert2';
  
  export default defineComponent({
    name: 'SpotFlexiblePatternContainer',
    
    components: {
      BillingInput,
    },
  
    // 修正5: フォーム入力用のローカルステートを定義
    data() {
      return {
        isLoading: false,
        localInputValue: null as CreateSpotFlexibleInput | null,
        localSpans: null as CreateSpansInput | null,
      }
    },
  
    computed: {
      isUpdatable(): boolean {
        return !!(this.$route.query && this.$route.query.category != null); 
      },
      // ストアのデータを監視用として取得
      storeInputValue(): CreateSpotFlexibleInput | null {
        return nurseryHoursModule.spotFlexiblePatternInput;
      },
      storeSpans(): CreateSpansInput | null {
        return nurseryHoursModule.spansInput;
      },
    },
  
    watch: {
      // ストアにデータが入ってきたら、手元（ローカル）にディープコピーする
      storeInputValue: {
        immediate: true,
        handler(newVal) {
          if (this.isUpdatable && newVal) {
            this.localInputValue = JSON.parse(JSON.stringify(newVal));
          }
        }
      },
      storeSpans: {
        immediate: true,
        handler(newVal) {
          if (this.isUpdatable && newVal) {
            this.localSpans = JSON.parse(JSON.stringify(newVal));
            // v-for のバグを防ぐため、各行に一意のIDを付与
            this.localSpans?.spans.forEach(span => {
              if (!(span as any)._id) (span as any)._id = Math.random().toString(36).substr(2, 9);
            });
          }
        }
      }
    },
  
    mounted() {
      // 新規作成モードの場合はローカルステートを初期化
      if (!this.isUpdatable) {
        this.initValues();
        this.initSpans();
        this.addSpanRow();
      }
    },
  
    methods: {
      initValues() {
        const nurseryId = LocalDataService.getNurseryId();
        if (nurseryId) {
          this.localInputValue = {
            nurseryId: nurseryId,
            patternTitle: '延長パターン',
          };
        }
      },
      initSpans() {
        this.localSpans = {
          patternId: '0',
          spans: [],
          spanCategory: 'normal',
        }
      },
      addSpanRow() {
        if (!this.localSpans) return;
        this.localSpans.spans.push({
          _id: Math.random().toString(36).substr(2, 9), // 行ごとに固有のIDを付与
          startingHour: 18,
          startingMinute: 0,
          endingHour: 18,
          endingMinute: 59,
          billingMethod: 'hourly',
          hourly: {
            billingMinute: 30,
            billingAmount: 100,
            billingUpperLimitAmount: 1000,
          },
          monthly: {
            billingAmount: 100,
          }
        } as any);
      },
  
      // APIを叩く直前に、手元のデータをストアに書き戻す
      async createPattern() {
        this.isLoading = true;
        const nurseryId = LocalDataService.getNurseryId();
  
        if (nurseryId && this.localInputValue) {
          // 保存直前にローカルステートをストアに同期
          nurseryHoursModule.setSpotFlexiblePatternInput(this.localInputValue);
  
          const response = await nurseryHoursModule.createSpotFlexiblePattern()
          .catch((e) => {
            alert("パターンの設定に失敗しました");
          });
  
          if (response) {
            if (response.patternId) {
              await this.createSpans(response.patternId)
              .catch((e) => {
                console.warn(e);
              });
            }
            Swal.fire({ title: '保存しました' });
            this.$router.push({ path: '/nursery-hours' });
          }
        }
        this.isLoading = false;
      },
  
      async updatePattern() {
        this.isLoading = true;
        const patternId = this.$route.query?.patternId;
  
        if (patternId && this.localInputValue) {
          // 保存直前にローカルステートをストアに同期
          nurseryHoursModule.setSpotFlexiblePatternInput(this.localInputValue);
  
          const response = await nurseryHoursModule.updateSpotFlexiblePattern({
            patternId: String(patternId),
          })
          .catch((e) => {
            alert("パターンの設定に失敗しました");
          });
  
          if (response) {
            if (response.patternId) {
              await this.updateSpans(response.patternId)
              .catch((e) => {
                console.warn(e);
              });
            }
            Swal.fire({ title: '保存しました' });
            this.$router.push({ path: '/nursery-hours' });
          }
        }
        this.isLoading = false;
      },
  
      async createSpans(patternId: string) {
        if (patternId && this.localSpans) {
          // patternId を上書きし、ストアに同期
          this.localSpans.patternId = patternId;
          nurseryHoursModule.setSpansInput(this.localSpans);
  
          await nurseryHoursModule.saveSpans()
          .catch((e) => {
            alert("不正な値が入力されています。時間枠の設定を見直して再度行ってください");
          });
        }
      },
  
      async updateSpans(patternId: string) {
        if (patternId && this.localSpans) {
          // patternId を上書きし、ストアに同期
          this.localSpans.patternId = patternId;
          nurseryHoursModule.setSpansInput(this.localSpans);
  
          await nurseryHoursModule.updateSpans()
          .catch((e) => {
            alert("不正な値が入力されています。時間枠の設定を見直して再度行ってください");
          });
        }
      },
    },
  })
  </script>